export default __webpack_public_path__ + "static/media/Group9237.b98dc466.svg";